"use client";

export default function GlobalError() { return <html><body><h2>Error</h2></body></html> }
